import React, { useCallback, useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import Button from 'components/common/button'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Loader from 'components/loader'

const LoadPreviousCta = ({ onLoadPreviousClicked, t }) => {
  const [isFetching, setIsFetching] = useState(false)
  const isUnmounted = useRef(false)

  useEffect(
    () => () => {
      isUnmounted.current = true
    },
    [],
  )

  const callOnLoadPreviousClicked = useCallback(() => {
    setIsFetching(true)

    onLoadPreviousClicked(() => {
      if (!isUnmounted.current) {
        setIsFetching(false)
      }
    })
  }, [onLoadPreviousClicked, setIsFetching])

  if (isFetching) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    )
  }

  return (
    <Button
      className="category-body__load-previous-cta"
      onClick={callOnLoadPreviousClicked}
    >
      {hasLocizeTranslation(t, 'CATEGORY_LOAD_PREVIOUS_BTN', 'Load Previous')}
    </Button>
  )
}

LoadPreviousCta.propTypes = {
  onLoadPreviousClicked: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default LoadPreviousCta
